module.exports = __webpack_public_path__ + "static/media/58.7aa2aaee.jpg";